import {h, Component } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import StatusCircle from '../ui-components/StatusCircle'
import {isChangeEvent} from '../../libs/typeGuards'

export interface TitleProps {
  title: string,
  onTitleChanged: CallableFunction,
  error: string,
  metadata: string,
  statusCircleVariant: null | 'draft'| 'published' | 'scheduled',
  published: boolean
}
interface State {
  titleInputVisible: boolean
}

class Title extends Component<TitleProps, State> {
  titleInputRef: HTMLElement | undefined

  constructor (props: TitleProps) {
    super(props)
    this.state = {
      titleInputVisible: false
    }

    this.onTitleClicked = this.onTitleClicked.bind(this)
    this.onClickOutsideOfTitle = this.onClickOutsideOfTitle.bind(this)
    this.onPressEnterInTitle = this.onPressEnterInTitle.bind(this)
  }

  componentDidMount () {
    document.addEventListener('mousedown', (e: MouseEvent) => this.onClickOutsideOfTitle(e))
    document.addEventListener('keypress', (e: KeyboardEvent) => this.onPressEnterInTitle(e))
  }

  onTitleClicked () {
    this.setState({ titleInputVisible: true }, () => {
      if (this.titleInputRef) {
        this.titleInputRef.focus()
      }
    })
  }

  onClickOutsideOfTitle (e: MouseEvent) {
    if (this.titleInputRef && !this.titleInputRef.contains(e.target as Node)) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  onPressEnterInTitle (e: KeyboardEvent) {
    if (this.titleInputRef && e.keyCode === 13) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  render ({ title, onTitleChanged, error, statusCircleVariant, published, metadata }: TitleProps, { titleInputVisible }: State) {
    return (
      <div className='create-topic-page_header__title'>
        {
          titleInputVisible ? (
            <input
              className='create-topic-page_header__title-input qa-create-topic-page_header__title-input form-control'
              type='text'
              value={title}
              required
              onChange={e => {
                if (isChangeEvent(e)) {
                  onTitleChanged(e.target.value.trim())
                }
              }}
              maxLength={250}
              ref={(titleInput) => {
                this.titleInputRef = titleInput
              }}
            />
          ) : (
            <div>
              <Tooltip
                trigger={
                  <h2
                    className={`create-topic-page_header__title-text qa-create-topic-page_header__title-text ${title ? '' : 'event-creator__title--empty'}`}
                    onClick={this.onTitleClicked}>{title || 'Untitled'}
                  </h2>}
                tooltipMessage={error ? error : title ? 'Rename' : 'Add a title'} //eslint-disable-line
                customClasses={error ? 'tooltip-show' : undefined}
                qaClasses='qa-title-tooltip'
              />
              <div className='create-topic-page_header__creation-status pull-left'>
                <StatusCircle variant={statusCircleVariant}/>
                <p className='create-topic-page_header-status-text'>
                  {metadata}
                </p>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

export default Title
